<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.edit_merchant_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #724c80">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <!-- Start:: Image Upload Input -->
          <base-image-upload-input
            col="12"
            identifier="admin_image"
            :preSelectedImage="data.image.path"
            :placeholder="$t('PLACEHOLDERS.logo')"
            @selectImage="selectImage"
          />
          <!-- End:: Image Upload Input -->

          <!-- Start:: Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.store_name')"
            v-model.trim="data.store_name"
            required
          />
          <!-- End:: Name Input -->

          <!-- Start:: Email Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
          />
          <!-- End:: Email Input -->

          <!-- Start:: Phone Input -->
          <base-input
            ref="phoneInput"
            col="6"
            type="tel"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            required
          />
          <!-- End:: Phone Input -->

          <!-- Start:: website Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.website')"
            v-model.trim="data.website"
            required
          />
          <!-- End:: website Input -->

          <!-- Start:: points_count Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.points_count')"
            v-model.trim="data.points_count"
            required
          />
          <!-- End:: points_count Input -->

          <!-- Start:: points_value Input -->
          <base-input
            col="6"
            type="number"
            :placeholder="$t('PLACEHOLDERS.points_value')"
            v-model.trim="data.points_value"
            required
          />
          <!-- End:: points_value Input -->

          <!-- Start:: desc Input -->
          <base-input
            col="7"
            rows="4"
            type="textarea"
            :placeholder="$t('SIDENAV.providers.description')"
            v-model.trim="data.desc"
            required
          />
          <!-- End:: desc Input -->

          <!-- Start:: Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.password')"
            v-model.trim="data.password"
            required
          />
          <!-- End:: Password Input -->

          <!-- Start:: Confirm Password Input -->
          <base-input
            col="6"
            type="password"
            :placeholder="$t('PLACEHOLDERS.confirmPassword')"
            v-model.trim="data.passwordConfirmation"
            required
          />
          <!-- End:: Confirm Password Input -->

          <!-- Start:: Deactivate Switch Input -->
          <div class="input_wrapper switch_wrapper my-5">
            <v-switch
              color="green"
              :label="
                data.active
                  ? $t('PLACEHOLDERS.active')
                  : $t('PLACEHOLDERS.notActive')
              "
              v-model="data.active"
              hide-details
            ></v-switch>
          </div>
          <!-- End:: Deactivate Switch Input -->

          <!-- Start:: Submit Button Wrapper -->
          <div class="btn_wrapper">
            <base-button
              class="mt-2"
              styleType="primary_btn"
              :btnText="$t('BUTTONS.save')"
              :isLoading="isWaitingRequest"
              :disabled="isWaitingRequest"
            />
          </div>
          <!-- End:: Submit Button Wrapper -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "CreateAdmin",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        image: {
          path: null,
          file: null,
        },
        name: null,
        store_name: null,
        points_count: null,
        points_value: null,
        desc: null,
        email: null,
        phone: null,
        website: null,
        password: null,
        passwordConfirmation: null,
        whatsApp: null,
        areas: [],
        active: true,
      },
      allAreas: [],
      // End:: Data Collection To Send
    };
  },

  computed: {
    // Start:: Vuex Getters
    ...mapGetters({
      allRoles: "ApiGetsModule/allRoles",
    }),
    // End:: Vuex Getters
  },

  methods: {
    // Start:: Vuex Actions
    ...mapActions({
      getRoles: "ApiGetsModule/getRoles",
    }),
    // End:: Vuex Actions

    // Start:: Select Upload Image
    selectImage(selectedImage) {
      this.data.image = selectedImage;
    },
    // End:: Select Upload Image

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      // this.isValidEmail = emailRegex.test(this.data.email);
      // if (!this.isValidEmail) {
      //   this.isWaitingRequest = false;
      //   return;
      // }
      //this.$message.error(this.$t("VALIDATION.email_domain"));
      //
      // if (!this.data.name) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.name"));
      //   return;
      // }
      // else if (!this.data.email) {
      //   this.isWaitingRequest = false;
      //   this.$message.error(this.$t("VALIDATION.email"));
      //   return;
      // }
      // else

      if (!this.data.phone) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.mobileNumber"));
        return;
      } else {
        this.submitForm();
        return;
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // // Start:: Append Request Data
      if (this.data.store_name) {
        REQUEST_DATA.append("name", this.data.store_name);
      }

      if (this.data.image.file) {
        REQUEST_DATA.append("image", this.data.image.file);
      }

      if (this.data.points_count) {
        REQUEST_DATA.append("points", this.data.points_count);
      }
      if (this.data.points_value) {
        REQUEST_DATA.append("points_value", this.data.points_value);
      }
      if (this.data.desc) {
        REQUEST_DATA.append("description", this.data.desc);
      }
      if (this.data.website) {
        REQUEST_DATA.append("website", this.data.website);
      }

      REQUEST_DATA.append("email", this.data.email);
      REQUEST_DATA.append("mobile", this.data.phone);
      if (this.data.password) {
        REQUEST_DATA.append("password", this.data.password);
      }
      if (this.data.passwordConfirmation) {
        REQUEST_DATA.append(
          "password_confirmation",
          this.data.passwordConfirmation
        );
      }
      REQUEST_DATA.append("is_active", +this.data.active);
      REQUEST_DATA.append("_method", "PUT");
      // Start:: Append Request Data

      try {
        await this.$axios({
          method: "POST",
          url: `vendors/${this.$route.params.id}`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        this.$router.push({ path: "/service-providers/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Get Data To Show
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `vendors/${this.$route.params.id}`,
        });

        this.data.image.path = res.data.data.Vendor?.avatar;
        this.data.store_name = res.data.data.Vendor?.name;

        this.data.points_count = res.data.data.Vendor?.points;
        this.data.points_value = res.data.data.Vendor?.points_value;
        this.data.desc = res.data.data.Vendor?.description;
        this.data.website = res.data.data.Vendor?.website;
        this.data.email = res.data.data.Vendor?.email;
        this.data.phone = res.data.data.Vendor?.mobile;
        this.data.active = res.data.data.Vendor?.is_active;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    // End:: Get Data To Show
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
    this.$nextTick(() => {
      this.data.phone = "";
    });
  },
};
</script>
